import { useQuery } from '@apollo/client/react';
import { Center, Spinner } from '@chakra-ui/react';
import { SidebarNestedNavList, SidebarNestedNavListSection } from '@src/components/sco/SidebarNestedNavList';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { gql } from '@src/lib/gql';
import { useParams } from 'next/navigation';
import React, { useMemo } from 'react';
export type LexiconSidebarNavProps = {
  collapsed?: boolean;
};
export const LexiconSidebarNav: React.FC<LexiconSidebarNavProps> = ({
  collapsed
}) => {
  const params = useParams();
  const lexiconArticleSlug = params.lexiconArticleSlug as string;
  const activeContent = useActiveContentContext();
  const breadcrumbHrefs = activeContent.breadcrumbs?.map(x => x.href).join(';');
  const {
    data,
    loading
  } = useQuery(gql`
    query {
      articles(first: 100, orderBy: title_ASC, where: { type: Lexicon, terms_some: { slug: "featured" } }) {
        id
        slug
        title
      }
    }
  `);
  const sections = useMemo<SidebarNestedNavListSection[]>(() => {
    if (!data?.articles) {
      return [];
    }
    return data.articles.map(article => {
      return {
        href: `/lexicon/${article.slug}`,
        title: article.title,
        isActive: activeContent.breadcrumbs?.some(b => b.href === `/lexicon/${article.slug}`)
      };
    });
  }, [data, lexiconArticleSlug, breadcrumbHrefs]);
  if (loading && !data) {
    return <Center py={4}>
        <Spinner size={'sm'} />
      </Center>;
  }
  return <SidebarNestedNavList sections={[{
    href: `/lexicon`,
    title: 'All Articles',
    activeExact: true
  }, {
    dividerProps: {}
  }, ...sections]} />;
};